import { console, window, document, setTimeout, navigator } from "global";
export const $ = window.$;
export const PostThis = window.top.postMessage;
// export const Origin = window.location.origin;

export const Origin = "https://e-dhq-bglcs.sec.se.com.sa:8021";
export const AncOrigin = "https://e-dhq-bglcs.sec.se.com.sa:8021/sap/bc/ui5_ui5/sap/ZUMCUI5_MOBILE/";
export let pageWidth = 0;

export const loader='<div class="message message-operator typing-indicator loading" style="transition: transform 0.2s ease 0s, margin 0.2s ease 0s">'+
'<i class="conv-icon">'+
'<svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">'+
'<path fill="#FF7300" d="M12.6731 7.71448H12.6486C14.4274 10.6186 14.8223 13.5835 13.6476 15.1736C12.0578 17.3287 7.89908 16.1389 4.3724 12.5162C0.920287 8.97696 -0.657088 4.42434 0.760652 2.2058C0.7276 2.2444 0.697191 2.28511 0.665473 2.329C-1.0372 4.62845 0.639618 9.64007 4.4159 13.5137C8.18791 17.3855 12.6322 18.6552 14.3375 16.3507C15.6809 14.5303 14.9093 11.0207 12.6731 7.71448ZM11.8358 6.28806C12.2843 6.81844 12.422 7.43792 12.1459 7.66345C11.8692 7.89268 11.2771 7.64547 10.8279 7.11086C10.3798 6.5752 10.2408 5.96021 10.5175 5.73336C10.7952 5.50968 11.3824 5.75425 11.8358 6.28806Z"></path><path fill="#FF7300" d="M6.091 0.862791C7.4273 1.02143 9.21304 1.80589 10.3161 3.01761C8.8748 1.25833 6.91566 0.0711909 5.03539 0.0029769C1.9853 -0.10569 0.275792 2.77411 1.22769 6.43519C1.36118 6.94336 1.53976 7.4428 1.75239 7.92585C2.05695 8.66061 2.47271 9.40937 3.01738 10.1296C3.37721 10.6105 3.77268 11.0534 4.19174 11.4722C3.89764 11.1663 3.61993 10.84 3.35789 10.4992C0.866571 7.18211 1.18419 3.51891 4.19174 2.45974C5.51035 1.99361 7.20483 2.19376 8.79137 2.71039C7.29645 1.68638 5.48713 1.04549 3.48319 1.71414C2.73932 1.96532 2.17898 2.41717 1.7969 3.00836C2.41678 1.46138 3.81128 0.589142 6.091 0.862791Z"></path>'+
'</svg>'+
'<span>Alkahraba</span></i>'+
'<span class="message-content"></span>'+
'<span class="message-content"></span>'+
'<span class="message-content"></span>'+
            '</div>';

const usericon=(lang)=> `<i class="conv-icon conv-user">
<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#ffffff" d="M3.12012 15.4209C2.72949 15.4209 2.42188 15.333 2.19727 15.1572C1.97754 14.9863 1.86768 14.7495 1.86768 14.4468C1.86768 13.978 2.00928 13.4824 2.29248 12.96C2.57568 12.4375 2.98584 11.9492 3.52295 11.4951C4.06006 11.0361 4.70703 10.665 5.46387 10.3818C6.22559 10.0938 7.08008 9.94971 8.02734 9.94971C8.97949 9.94971 9.83398 10.0938 10.5908 10.3818C11.3525 10.665 11.9995 11.0361 12.5317 11.4951C13.0688 11.9492 13.479 12.4375 13.7622 12.96C14.0503 13.4824 14.1943 13.978 14.1943 14.4468C14.1943 14.7495 14.082 14.9863 13.8574 15.1572C13.6377 15.333 13.3325 15.4209 12.9419 15.4209H3.12012ZM8.03467 8.63867C7.51221 8.63867 7.02881 8.49707 6.58447 8.21387C6.14014 7.92578 5.78125 7.54004 5.50781 7.05664C5.23926 6.56836 5.10498 6.02148 5.10498 5.41602C5.10498 4.82031 5.23926 4.2832 5.50781 3.80469C5.78125 3.32617 6.14014 2.94775 6.58447 2.66943C7.02881 2.39111 7.51221 2.25195 8.03467 2.25195C8.55713 2.25195 9.04053 2.38867 9.48486 2.66211C9.9292 2.93555 10.2856 3.31152 10.5542 3.79004C10.8276 4.26367 10.9644 4.80078 10.9644 5.40137C10.9644 6.01172 10.8276 6.56104 10.5542 7.04932C10.2856 7.5376 9.9292 7.92578 9.48486 8.21387C9.04053 8.49707 8.55713 8.63867 8.03467 8.63867Z" /></svg>
<span>${lang==="ar"?'أنت':'You'}</span></i>`;
export const userContainerPre=(lang)=>`<div class="message message-visitor">${usericon(lang)}<span class="message-content">`;
export const userContainerPost = '</span></div>';
export const userNumberInputedPre = '<div class="Tnumber">';
export const userNumberInputedPost = '</div>';
export const useralphaNumberInputedPre = '<div class="Talphanum">';
export const useralphaNumberInputedPost = '</div>';

export const timeoutPre='<div class="message message-operator tout">'+
            '<span class="message-content">';	 			
export const timeoutPost='</span></div>';

export const isMobileDevice=()=>{
    return /Mobi|Android/i.test(navigator.userAgent);
}

export const isiPhone=()=>{
    return /iPhone/i.test(navigator.userAgent);
}

export const isAndroid=()=>{
    return /Android/i.test(navigator.userAgent);
}

export const getPageType = function () {
    $(document).ready(function () {
        pageWidth = $(window).width();
        if ((/Android|iPhone|Windows Phone/i.test(navigator.userAgent)) || pageWidth<450) {
            // Take the user to a different screen here.
            $('body').addClass('mobile');
            // console.log('mobile');
        } else {
            $('body').removeClass('mobile');
        }
    })
};

const isBackOrMainMenuButton = (input)=>{
    if(input==='Back' || input==='الرجوع للخلف' || input==='القائمة الرئيسية' || input==='Main Menu'){
        return true;
    }
    return false;
}

export const getConv = function (userio, type, svg='', lang='en') {
    // console.log(userio);
    let user ='';
    // if (userio != '{failure}' && userio != '{success}' && !isBackOrMainMenuButton(userio) && type!=="File")
    if (userio != '{failure}' && userio != '{success}' && !isBackOrMainMenuButton(userio))
    {
    	if(type==='Account' || (type==='OTP' && userio !== 'إعادة ارسال رمز التحقق') || type==='Request' || type==='UDS' || type==='Location' || type==='NationalId' || type==='IBAN' || type==='Payment' || type==='DatePicker'){
            user = userContainerPre(lang) + userNumberInputedPre + userio + userNumberInputedPost + userContainerPost;
        } else if(type==='Phone'){
        	user = userContainerPre(lang) + useralphaNumberInputedPre + userio + useralphaNumberInputedPost + userContainerPost;
        } else if(type==='Submenu' || type==="Mainmenu"){
            if(lang==='ar'){
                user = userContainerPre(lang) + svg + " " + userio + userContainerPost;
            } else {
                user = userContainerPre(lang) + userio + " " + svg + userContainerPost;
            }
        } else {
            user = userContainerPre(lang) + userio + userContainerPost;
        }     
        if(type!=='PropertyParam'){
            $('.message-container').append(user);
            setTimeout(()=>{handlePrevActions()},210);
            setTimeout(()=>{scrollBot()},550);
        }  
        
    // } else if(isBackOrMainMenuButton(userio)) {
    //     setTimeout(()=>{handlePrevActions()},300);
    //     setTimeout(()=>{scrollBot()},650);
    }
    // $('#fb-popup').show();
};

export const cancelFeedback = function (t) {
    // console.log(t);
    $('#fb-popup').hide();
};

export const checkUserTextValue = function(usrio,type,var1){
    let isMobile = $('#usertext').hasClass('validMobile');
    let isAccount = $('#usertext').hasClass('validAccount');
    let isPayment = $('#usertext').hasClass('validPayment');
    let isRequest = $('#userRquest').hasClass('validRequest');
    let isUDS = $('#userUDS').hasClass('validUDS');
    let isIBAN = $('#userIBAN').hasClass('isIBAN');
    let isNationalId = $('#usertextnational').hasClass('isNationalId');
    let isMobileValid = false;
    let isAccountValid = false;
    let isPaymentValid = false;
    let isRequestValid = false;
    let isUDSValid = false;
    let isIBANValid = false;
    let isNationalIdValid = false;
    let reg;
    if(type==='File'){
        reg = new RegExp("[~!#$%^{}\"<>|]");
    } else {
        reg = new RegExp("[~!#$%^(){}\"<>|]");
    }
    
    var userAccMatch = false;
    if(isBackOrMainMenuButton(usrio)){
    	userAccMatch = true;
    }else {
    	var accountUserRegex = /^(3)[0-9]{10}$/;
        userAccMatch = accountUserRegex.test(usrio);
    }    
   
    // console.log(usrio);
    // console.log('Is corrupted: ',reg.test(usrio));
    if(isMobile){
    	if(isBackOrMainMenuButton(usrio)){
    		isMobileValid = true;
    	}else {
    		isMobileValid = checkValidMobile(usrio);
    	}
        // isMobileValid = true;		
        // console.log('Is Mobile: ',isMobileValid);
    }
    if(isAccount){	    
	    if(isBackOrMainMenuButton(usrio)){
	    	isAccountValid = true;
	    }
	    else{	    	
	    	isAccountValid = checkValidAccount(usrio);
	    }    	
        // console.log('Is Account: ',isAccountValid);  
    }
    if(isRequest){	    
	    if(isBackOrMainMenuButton(usrio)){
	    	isRequestValid = true;
	    }
	    else{	    	
	    	isRequestValid = checkValidRequest(usrio);
	    }    	
        // console.log('Is request: ',isRequestValid);  
    }
    if(isUDS){	    
	    if(isBackOrMainMenuButton(usrio)){
	    	isUDSValid = true;
	    }
	    else{	    	
	    	isUDSValid = checkValidUDS(usrio);
	    }
    }
    if(isPayment){
	    isPaymentValid = checkValidPayment(usrio);
        // console.log('Is Payment: ',isPaymentValid);
    }
    if(isIBAN){
	    if(isBackOrMainMenuButton(usrio)){
    		isIBANValid = true;
	    }
	    else{	    	
	    	isIBANValid = checkValidIBAN(usrio);
	    }
        // console.log('Is IBAN: ',isIBANValid);
    }
    if(isNationalId){
	    if(isBackOrMainMenuButton(usrio)){
    		isNationalIdValid = true;
	    }
	    else{	    	
	    	isNationalIdValid = false;
	    }
        // console.log('Is National ID: ',isNationalIdValid);
    }
    
    if(usrio==='' || usrio.length===1){
        return false;
    } else if(usrio!=='' && reg.test(usrio)){
        return false;
    } else if(usrio!=='' && usrio.length<4 && type==='OTP'){
        return false;
    } else if(usrio!=='' && usrio.length<10 && type==='NationalId' && !isNationalIdValid){
        return false;
    } else if(usrio!=='' && type==='Phone' && !isMobileValid){
        return false;
    } else if(usrio!=='' && type==='Account' && var1 !== 'var1' && var1 !== '' && !userAccMatch){
        return false;
    } else if(usrio!=='' && type==='Account' && var1 === 'var1' && !isAccountValid){
		return false;
    } else if(usrio!=='' && type==='Request' && var1 === 'var1' && !isRequestValid){
		return false;
    } else if(usrio!=='' && type==='UDS' && var1 === 'var1' && !isUDSValid){
		return false;
    } else if(usrio!=='' && type==='IBAN' && !isIBANValid){
		return false;
    } else {
        return true;
    }
};

export const getUserTextOTPValue = function(){
    let isVal = $('#usertextt').val();
    let isFVal=isVal.replace(/ /g, '');
    return isFVal;
};

export const getUserTextNationalIdValue = function(){
    let isVal = $('#usertextnational').val();
    let isFVal=isVal.replace(/ /g, '');
    return isFVal;
};

export const getUserTextIBANValue = function(){
    let isVal = $('#userIBAN').val();
    let isFVal=isVal.replace(/ /g, '');
    return isFVal;
};

export const getUserTextPhoneValue = function(){
    let isVal = $('#userPhone').val();
    let isFVal=isVal.replace(/ /g, '');
    return isFVal;
};

export const getUserTextRequestValue = function(){
    let isVal = $('#userRquest').val();
    let isFVal=isVal.replace(/ /g, '');
    return isFVal;
};

export const getUserTextUDSValue = function(){
    let isVal = $('#userUDS').val();
    let isFVal=isVal.replace(/ /g, '');
    return isFVal;
};

export const checkValidMobile = function(usrio){
    // var phoneRegex =
	// /^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/;
    var newVal = usrio.split("+966");
    var phoneRegex = /^[0-9]{9}$/;
    var match = phoneRegex.test(newVal[1]);
    return match;
};

export const checkValidAccount = function(usrio){
    var accountRegex = /^[0-9]{11}$/;
    var match = accountRegex.test(usrio);
    return match;
};

export const checkValidPayment = function(usrio){
    var paymentRegex = /^[0-9]$/;
    var match = paymentRegex.test(usrio);
    return match;
};

export const checkValidIBAN = function(usrio){
    var newVal = usrio.split("SA");
    var ibanRegex = /^[0-9]{22}$/;
    var match = ibanRegex.test(newVal[1]);
    return match;
};

export const checkValidOTP = function(usrio){
    var otpRegex = /^[0-9]{4}$/;
    var match = otpRegex.test(usrio);
    return match;
};
export const checkValidRequest = function(usrio){
    var reqRegex = /^[0-9]{8,9}$/;
    var match = reqRegex.test(usrio);
    return match;
};
export const checkValidUDS = function(usrio){
    var reqRegex = /^[0-9]{9}$/;
    var match = reqRegex.test(usrio);
    return match;
};

export const forOTP = function(t){
    setTimeout(function(){
        var cleave = new Cleave('#usertextt', {
            delimiter: '',
            blocks: [1, 1, 1, 1],
            uppercase: true,
            numericOnly: true
        });
    }, 700);
};

export const forNationalId = function(t){
    setTimeout(function(){
        var cleave = new Cleave('#usertextnational', {
            delimiter: '',
            blocks: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
            uppercase: true,
            numericOnly: true
        });
    }, 700);
};

export const forIBAN = function(t){
    setTimeout(function(){
        var cleave = new Cleave('#userIBAN', {
            prefix: 'SA',
            delimiter: ' ',
            blocks: [2, 4, 4, 4, 4, 4, 2],
            uppercase: true,
            numericOnly: true
        });
    }, 700);
};

export const forPhone = function(t){
    setTimeout(function(){
        var cleave = new Cleave('#userPhone', {
            prefix: '+966',
            delimiter: ' ',
            blocks: [4, 9],
            uppercase: true,
            numericOnly: true
        });
    }, 700);
};

export const forRequest = function(t){
    setTimeout(function(){
        var cleave = new Cleave('#userRquest', {
            delimiter: '',
            blocks: [1, 1, 1, 1, 1, 1, 1, 1, 1],
            uppercase: true,
            numericOnly: true
        });
    }, 700);
};

export const forUDS = function(t){
    setTimeout(function(){
        var cleave = new Cleave('#userUDS', {
            delimiter: '',
            blocks: [1, 1, 1, 1, 1, 1, 1, 1, 1],
            uppercase: true,
            numericOnly: true
        });
    }, 700);
};

export const appendUserTextMessage = function (lang,type,var1) {
    // console.log('Usertext error: ');
    let messageContainer = $('.message-container');
    const elementkeep = document.querySelector('.keep');
    const elementabc = document.querySelector('.abc');
    if (elementkeep) elementkeep.remove();
    if (elementabc) elementabc.remove();
    let pre = '<div class="message message-operator abc"><span class="message-content">';
    let preKeep = '<div class="message message-operator keep"><span class="message-content">';
    let botContainerPost = '<span></div>';
    let error='';
    if(lang==='ar'){
        if(type==='OTP'){
            error = pre + "رمز التحقق يجب ألا يقل عن 4 خانات" + botContainerPost;
        } else if(type==='NationalId'){
            error = pre + "رقم الهوية الوطنية مكون من 10 أرقام" + botContainerPost;
        } else if(type==='Account' && var1 !== 'var1' && var1 !==''){
            error = pre + ",فضلاً أختر من القائمة الحسابات الخاصة بكم" + botContainerPost;
        } else if(type==='Account' && var1 ==='var1'){
            error = pre + "الرجاء إدخال رقم حساب صالح" + botContainerPost;
        } else if(type==='Phone'){
            error = pre + "الرجاء إدخال رقم هاتف صحيح" + botContainerPost;
        } else if(type==='File' || type==='invalidimage'){
            error = preKeep + "يرجى تحميل ملف صالح. \n التنسيقات المسموح بها: jpg، png، pdf، doc، docx. حجم الملف لا يزيد عن 5.5 ميغا بايت." + botContainerPost;
        } else if(type==='IBAN'){
            error = pre + "رقم الهوية الوطنية مكون من 24 أرقام" + botContainerPost;
        } else if(type==='Payment') {
            error = pre + "الرجاء إدخال استعلام صالح." + botContainerPost;
        } else if(type==='Request') {
            error = pre + "رقم التذكرة المدخل غير صحيح" + botContainerPost;
        } else if(type==='UDS') {
            error = pre + "رقم التذكرة المدخل غير صحيح" + botContainerPost;
        } else {
            error = pre + "يرجى إدخال استفسارك بشكل صحيح" + botContainerPost;
        }
    } else {
        if(type==='OTP'){
            error = pre + "OTP should not be less than 4 digits" + botContainerPost;
        } else if(type==='NationalId'){
            error = pre + "National ID is a 10 digit number" + botContainerPost;
        } else if(type==='Account' && var1 !== 'var1' && var1 !==''){
            error = pre + "Please select contract account number from the drop-down list." + botContainerPost;
        } else if(type==='Account' && var1==='var1'){
            error = pre + "Please enter valid Account number" + botContainerPost;
        } else if(type==='Phone'){
            error = pre + "Please enter valid Phone number" + botContainerPost;
        } else if(type==='File' || type==='invalidimage'){
            error = preKeep + "Please upload valid file.\nAllowed Formats: jpg, png, pdf, doc, docx. File size not greater than 5.5 MB." + botContainerPost;
        } else if(type==='IBAN'){
            error = pre + "Please enter valid IBAN number. IBAN is a 24 digit number" + botContainerPost;
        } else if(type==='Payment'){
            error = pre + "Please enter valid Payment" + botContainerPost;
        } else if(type==='Request'){
            error = pre + "Please enter vaild Request number." + botContainerPost;
        } else if(type==='UDS'){
            error = pre + "Please enter vaild Request number." + botContainerPost;
        } else {
            error = pre + "Please enter your inquiry correctly." + botContainerPost;
        }
    }
    setTimeout(()=>{messageContainer.append(error);$('#usertext').val('');},150);
    setTimeout(()=>{scrollBot()},200);
    setTimeout(()=>{$('.abc').fadeOut('blind');},3000);
    setTimeout(()=>{$('.keep').fadeOut('blind');},30000);
};

export const closeNotification = function (t) {
    // console.log('Close notify: ', t);
    let notify = $('#notify');    
    setTimeout(()=>{notify.removeClass('active')},150);    
};

export const appendLoader = function () {
    let messageContainer = $('.message-container');
    $('.loading').hide();
    if( $('.tout').length ){
        $('.tout').remove();
    }
    setTimeout(()=>{messageContainer.append(loader)},10);
    setTimeout(()=>{scrollBot()},200);
};

export const removeLoader = function(t){
    $(".loading").slideUp(700, function() {
        $(this).hide();
    });
    // setTimeout(()=>{$('.loading').remove()},700);
    if(t==='OTP'){
        setTimeout(()=>{$('#usertextt').focus()},800);
    } else if(t==='NationalId'){
        setTimeout(()=>{$('#usertextnational').focus()},800);
    } else if(t==='IBAN'){
        setTimeout(()=>{$('#userIBAN').focus()},800);
    } else if(t==='Phone'){
        setTimeout(()=>{$('#userPhone').focus()},800);
    } else if(t==='Request'){
        setTimeout(()=>{$('#userRquest').focus()},800);
    } else {
        setTimeout(()=>{$('#usertext').focus()},800);
    }
    setTimeout(()=>{ scrollBot() },1000);
    // $(".scrollbar-container").animate({ scrollTop: "-=15px" }, 150);
};

export const guidGenerator = function () {
    var S4 = function() {
       return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    };
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
};

export const scrollBot = function(){
    $(".scrollbar-container").animate({
        scrollTop: $('.scrollbar-container').prop("scrollHeight")
    }, 1000);
};

export const handlePrevActions = function(){
    let calcHeight=100;
    // $(".button-wrapper:last").closest('.message.message-operator').slideUp(calcHeight,
	// function() {
    // $(this).hide();
    // });
     $(".select-wrapper:last").closest('.message.message-operator').slideUp(calcHeight, function() {
         $(this).hide();
     });
    $(".button-wrapper:last").addClass("disabled");
    $(".message-properties:last").addClass("disabled");
    $(".uploadSVG:last").prop("disabled", true);
    $(".uploadSVG:last").attr("disabled", true);
    // $(".select-wrapper:last").addClass("disabled");
    // setTimeout(()=>{scrollBot()},200);
};

export const handleInvalidImage = function(){
    setTimeout(() => {
        $(".button-wrapper:last").removeClass("disabled");
        $(".uploadSVG:last").prop("disabled", false);
        $(".uploadSVG:last").attr("disabled", false);        
    }, 500);
    setTimeout(() => {
        // Hide the last element with the class 'invalid-ele'
        var invalidEle = document.querySelectorAll('.invalid-ele');
        if (invalidEle.length > 0) {
        invalidEle[invalidEle.length - 1].style.display = 'none';
        }

        // Hide the last element with the class 'message message-visitor'
        var messageVisitor = document.querySelectorAll('.message.message-visitor');
        if (messageVisitor.length > 0) {
        messageVisitor[messageVisitor.length - 1].style.display = 'none';
        }
    }, 7000);
};

export const resetMessageContainer = function(){
    let messageContainer = $('.message-container');
    setTimeout(()=>{messageContainer.html('')},150);
};

export const resetVisitorsMessages = function(){
    let messageUsersContainer = $('.message.message-visitor');
    messageUsersContainer.hide();
    setTimeout(()=>{messageUsersContainer.remove()},150);
};

// export const getBase64 = file => {
//     return new Promise(resolve => {
//         let baseURL = "";
//         // Make new FileReader
//         let reader = new FileReader();
//         // Convert the file to base64 text
//         reader.readAsDataURL(file);
//         // on reader load somthing...
//         reader.onload = () => {
//             // Make a fileInfo Object
//             baseURL = reader.result;
//             resolve(baseURL);
//         };
//     });
// };

export const getBase64 = (file, onProgress) => {
    return new Promise((resolve, reject) => {
        let baseURL = "";
        let reader = new FileReader();

        // Listen for progress updates
        reader.onprogress = (event) => {
            if (event.lengthComputable && onProgress) {
                const progress = Math.round((event.loaded / event.total) * 100);
                onProgress(progress);  // Call the onProgress callback with the percentage
            }
        };

        // Handle the file conversion to base64
        reader.readAsDataURL(file);

        // On load success
        reader.onload = () => {
            baseURL = reader.result;
            resolve(baseURL);  // Resolve the base64 string
        };

        // On load error
        reader.onerror = (error) => {
            reject(error);  // Reject the promise with the error
        };
    });
};

export const openLiveAgent = function(name, account, phone, chathistory, language, var1, entryPointId, templateName, locale) {
	var egainChat  = egainChat  || {};
    let wsname = "";
    let phone_number = "";
    
    let cust_text = "";
    let cname = "";
    /* eGain Chat server */
    // egainChat.serverURL = "https://rmt-dcapp-ecweb.sec.se.com.sa/system"; /*UAT link*/
    egainChat.serverURL = "https://livechat.se.com.sa//system"; /*Prod link*/
    /* eGain Chat Entry Point */

    // For UAT
    // if(language==='ar'){
    //     egainChat.EntryPointId  = "1002";
    //     egainChat.Template = "Cbot_Ar";
    //     egainChat.templateName = "Cbot_Ar";
    // 	   egainChat.Locale  = "ar-AE";
    // }else{
    //     egainChat.EntryPointId  = "1003";
    //     egainChat.Template = "Cbot_En";
    //     egainChat.templateName = "Cbot_En";
    // 	   egainChat.Locale  = "en-US";
    // }

    // For Prod
    egainChat.EntryPointId  = entryPointId || "1007";
    egainChat.Template = templateName || "Cbot_Ar";
    egainChat.templateName = templateName || "Cbot_Ar";;
    egainChat.Locale  = locale || "ar-AE"
    /* eGain Chat Locale */
    
    egainChat.PostChatAttributes = false;
    egainChat.CustomerContextParameters = {};
    /* Setting Custom Template based Customer Parameters */
    if(name === null){
        if(language=== "ar"){
            name = "عميل";
            
        }else{
            name = "Customer";
            
        }
    }
    if(phone === null){
        phone = 0;
    }
    if(var1 !== 'var1' && var1 !== ''){
        wsname = "https://www.se.com.sa";
    }else{
        wsname = "https://www.se.com.sa";
    }

    if(language === 'ar'){
        let nm = decodeURI(name).replace(/\+/g,' ').replace('Start','بداية').replace('hi','أهلا');

        egainChat.Customer_Name = encodeURIComponent(nm);
        egainChat.Contract_Account = encodeURIComponent(account);
        
        phone_number = phone.replace(/\+/g,'');
        egainChat.Phone_Number = encodeURIComponent(phone_number);
        let text = decodeURI(chathistory).replace(/\+/g,' ').replace(/\%3A/g,'->').replace(/\%2F/g,'-').replace(/\:/g,' ').replace(/\-/g,' ').replace('Start','بداية').replace('hi','أهلا').replace(/Customer/g,'عميل').replace(/Bot/g,'الشات بوت').replace(/&commat;/g,'(at)');
        console.log(text);
        egainChat.Subject =encodeURIComponent(text);
        // egainChat.Subject = encodeURIComponent("عنصر نائب لمحفوظات
		// الدردشة")//encodeURIComponent(chathistory);        
        cust_text = encodeURIComponent("المحادثة المباشرة");
        cname = encodeURIComponent("أنت");
    }
    else{
        egainChat.Customer_Name = encodeURIComponent(name);
        egainChat.Contract_Account = encodeURIComponent(account);
        phone_number = phone.replace(/\+/g,'');
        egainChat.Phone_Number = encodeURIComponent(phone_number);
 
		let text = chathistory.replace(/\+/g,' ').replace(/\%3A/g,'->').replace(/\%2F/g,'-').replace(/\:/g,'->').replace(/\//g,'-').replace(/\?/g,'').replace(/\,/g,' ').replace(/&commat;/g,'(at)');
     
        egainChat.Subject = encodeURIComponent(text);        
        cust_text = encodeURIComponent("Live Chat");
        cname = encodeURIComponent("You");
    }
    // egainChat.Chat_History = chathistory;

    egainChat.openHelp = function () {
    var domainRegex = /^((?:https?:\/\/)?(?:www\.)?([^\/]+))/i;
    try {
        if (egainChat.eglvchathandle != null && egainChat.eglvchathandle.closed == false) {
            egainChat.eglvchathandle.focus();
            return;
        }
    }
    catch (err) {
    }
    var refererName = "Chatbot";
    refererName = encodeURIComponent(refererName);
    var refererurl = encodeURIComponent(document.location.href);
    var hashIndex = refererurl.lastIndexOf('#');
    if (hashIndex != -1) {
        refererurl = refererurl.substring(0, hashIndex);
    }
    var eglvcaseid = (/eglvcaseid=[0-9]*/gi).exec(window.location.search);
    var vhtIds = '';
    if (typeof EGAINCLOUD != 'undefined' && EGAINCLOUD.Account.getAllIds)
    {
        var ids = EGAINCLOUD.Account.getAllIds();
        vhtIds = '&aId=' + ids.a + '&sId=' + ids.s + '&uId=' + ids.u;
    }
    var EG_CALL_Q = window.EG_CALL_Q || [];
    EG_CALL_Q.push(['enableTracker', true]);
     var eGainChatUrl = egainChat.serverURL + '/templates/chat/' +
	 egainChat.Template + '/chat.html?subActivity=Chat&entryPointId=' +
	 egainChat.EntryPointId;
   
     eGainChatUrl += "" +
        "&templateName=" + egainChat.templateName +
        "&ver=v11&locale=" + egainChat.Locale +
        "&wsname=" + wsname;
     eGainChatUrl += "&postChatAttributes=" + egainChat.PostChatAttributes +
        "&eglvrefname=" + refererName +
        "&" + eglvcaseid + vhtIds +
        "&fieldname_1=" + cname +
        "&fieldname_2=" + egainChat.Contract_Account +
        "&fieldname_3=" + egainChat.Phone_Number +
        "&fieldname_4=" + egainChat.Subject +
        "&fieldname_5=" + cust_text +
        "&wsname=" + wsname;
    
    
    
    var domain = domainRegex.exec(eGainChatUrl)[0];
   
    if ((eGainChatUrl + refererurl).length <= 2000)
    	eGainChatUrl += '&referer=' + refererurl;
    var params = 'height=650,width=450,resizable=no,scrollbars=yes,toolbar=no';
   
    if (egainChat.PostChatAttributes) {
        window.addEventListener('message', function (event) {
            try{
                var message = JSON.parse(event.data);
                if (event.origin === domain && message.Caller.indexOf('EGLV_DOCK') !== -1) {
                    if (message.Key === 'EgainChatParameter') {
   
                        var response = {
                            value: egainChat.CustomerContextParameters,
                            caller: message.Caller
                        };
                        event.source.postMessage(JSON.stringify(response), event.origin);
                    }
                }
            }catch(e){
            }
        });
    }
	console.log(eGainChatUrl);
    egainChat.eglvchathandle = window.open(eGainChatUrl, '_self', params);
    };
    /*
	 * To be called by client website. All the parameters specified in
	 * application-chat-defaults must be set here.
	 */
    egainChat.SetCustomerParameters = function (egainAttributeName, attributeValue) {
        egainChat.CustomerContextParameters[egainAttributeName] = attributeValue;
    };
    /*
	 * Setting iFrame source variable as it was not present by default as
	 * mentioned in the documentation: Enterprise Chat and Email Administrator’s
	 * Guide to Chat and Collaboration Resources, Release 11.6(1) Page 112 Point
	 * No. 7
	 */
    // iframe.src=egainChat.serverURL+'/web/view/live/customer/storeparams.html&wsname=https://sec-chatbot-uat.sec.se.com.sa'
    egainChat.openHelp()
 };